import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Etiquetas del paginador en español. Se provee en el módulo raíz, así que
 * aplica a todas las tablas del sistema (antes decían "Items per page" y
 * "1 – 10 of 23" en una interfaz que por lo demás está en español).
 */
@Injectable()
export class PaginatorEs extends MatPaginatorIntl {
  itemsPerPageLabel = 'Registros por página';
  nextPageLabel = 'Página siguiente';
  previousPageLabel = 'Página anterior';
  firstPageLabel = 'Primera página';
  lastPageLabel = 'Última página';

  getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    const inicio = page * pageSize;
    const fin = Math.min(inicio + pageSize, length);
    return `${inicio + 1} – ${fin} de ${length}`;
  };
}
